<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/packages">{{$t('packaging')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="saveClick"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table-print">
                                <tbody>
                                    <tr>
                                        <td>{{$t('receiver')}}</td>
                                        <td>:</td>
                                        <td>
                                            <select class="form-control form-control-sm" v-model="receiver">
                                                <option value=""></option>
                                                <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.KhmerName }}</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px; vertical-align: top;">{{$t('branch_name')}}</td>
                                        <td style="vertical-align: top;">:</td>
                                        <td>
                                            <ul class="inline-list">
                                                <li v-for="ret in branches" :key="ret.Id"><input type="checkbox" v-model="ret.Checked"/> {{ret.Name}}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="table-print" align="right">
                                <tbody>
                                <tr>
                                    <td>{{$t('code')}}</td>
                                    <td>:</td>
                                    <td><input type="text" class="form-control form-control-sm" v-model="header.Num" readonly/></td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td><input type="date" class="form-control form-control-sm" v-model="date"/></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="blue text-center v-middle" style="width: 50px;">{{$t('no')}}</th>
                                        <th class="blue v-middle">{{$t('item_name')}}</th>
                                        <th class="blue text-center v-middle" style="width: 120px;">{{$t('qty_base')}}</th>
                                        <th class="blue text-center v-middle" style="width: 120px;">{{$t('qty_remain')}}</th>
                                        <template v-for="ret in branches">
                                            <th v-if="ret.Checked" class="blue text-center v-middle" style="width: 120px;" :key="ret.Id">{{ret.Name}}</th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(ret, index) in lines">
                                        <tr :key="index" v-if="ret.ToQuantity > 0">
                                            <td class="text-center">{{index+1}}</td>
                                            <td>{{ret.ItemName}}</td>
                                            <td class="text-center">{{ret.ToQuantity}}</td>
                                            <td class="text-center">{{ret.Remain}}</td>
                                            <template v-for="branch in ret.Branches">
                                                <td v-if="branch.Checked" class="table-cell" :key="branch.Id">
                                                    <input type="number" class="form-control form-control-sm" v-model="branch.Quantity" @blur="qtyChange(ret)"/>
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            title: this.$t('packaging_stock'),
            header: {},
            lines: [],
            isStockIn: false,
            branches: [],
            date: this.$now().format('YYYY-MM-DD'),
            receiver: '',
            employees: []
        }
    },
    created(){
        this.employeeList();
        let id = this.$route.params.id;
        if(id !== undefined && id !== null && id !== ''){
            this.findById(id);
        }
    },
    methods: {
        saveClick(){
            var req = [];
            for(var i = 0; i < this.branches.length; i++){
                var branch  = this.branches[i];
                if(branch.Checked){
                    var gLines = []
                    var header = {
                        BranchId: branch.Id,
                        InDateAt: this.date,
                        EmployeeId: this.receiver,
                        DocSource: 'Package',
                        DocSourceNo: this.header.Num
                    };
                    for(var j = 0; j < this.lines.length; j++){
                        var line = this.lines[j];
                        var obj = {
                            ItemId: line.ItemId,
                            UomId: line.ToUomId,
                            UomName: line.ToUomName,
                            Quantity: line.Branches[i].Quantity,
                            QuantityIn: line.Branches[i].Quantity
                        };
                        if(obj.Quantity > 0) gLines.push(obj);
                    }
                    if(gLines.length > 0){
                        req.push({
                            Header: header,
                            Lines: gLines
                        });
                    }
                }
            }
            let loading = this.$loading.show();
            this.$api().post('package/stockin/save', req).then(res => {
                if(this.$isValid(res)){
                    this.$router.push('/stockin');
                }
            }).finally(function() { loading.hide(); });
        },
        findById(id){
            let loading = this.$loading.show();
            this.$api().post('package/find', { Id: id,  IsIncludeBranch: true }).then(res => {
                if(this.$isValid(res)){
                    let data = res.data.Json;
                    var branches = data.Branches;
                    for(var i = 0; i < branches.length; i++){
                        this.branches.push({
                            Checked: false,
                            Id: branches[i].Id,
                            Name: branches[i].Name,
                            Quantity: 0
                        });
                    }
                    this.header = data.Header;
                    this.title = '['+this.header.Num+']';
                    this.header.Date = this.$format(this.header.Date, 'YYYY-MM-DD');
                    var lines = data.Lines;
                    for(var j = 0; j <lines.length; j++){
                        var qty = lines[j].ToQuantity - lines[j].TransferQuantity
                        lines[j].ToQuantity = qty;
                        lines[j].Remain = qty;
                        lines[j].Branches = this.branches;
                    }
                    this.lines = lines;
                }
            }).finally(function() { loading.hide(); });
        },
        qtyChange(item){
            var total = 0
            item.Branches.forEach(element => {
                total += Number(element.Quantity);
            });
            item.Remain = item.ToQuantity - total;
        },
        employeeList(){
            this.$api().post('employees').then(res => {
                if(this.$isValid(res)){
                    this.employees = res.data.Data;
                }
            });
        }
    }
}
</script>
<style scoped>
    .inline-list{
        display: flex;
        padding: 0;
        margin: 0;
    }
    .inline-list li{
        list-style-type: none;
        margin-right: 15px;;
    }
    .table-cell{
        padding: 0;
    }
    .table-cell .form-control{
        border-radius: 0;
        border: none;
        background: #f2f2f2;
    }
    .v-middle{
        vertical-align: middle;
    }
</style>